import { render, staticRenderFns } from "./RiskInformation.vue?vue&type=template&id=99adc4b6&scoped=true&"
import script from "./RiskInformation.vue?vue&type=script&lang=js&"
export * from "./RiskInformation.vue?vue&type=script&lang=js&"
import style0 from "./RiskInformation.vue?vue&type=style&index=0&id=99adc4b6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99adc4b6",
  null
  
)

export default component.exports